import { Box, Heading } from "@chakra-ui/react";
import React from "react";
import LoginModel from "../Components/login/LoginSetUp";

const Login = () => {
  return (
    <Box>
      <LoginModel />
    </Box>
  );
};

export default Login;
